import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the route has a hash, scroll to that section.
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));

      requestAnimationFrame(() => {
        const target = document.getElementById(id);
        if (!target) {
          return;
        }

        const navOffset = 80; // fixed nav height + spacing
        const top = target.getBoundingClientRect().top + window.scrollY - navOffset;
        window.scrollTo({ top, behavior: "smooth" });
      });
      return;
    }

    // Otherwise, scroll to top when pathname changes.
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
